import { Component, Input } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { SidebarService } from '@apiKm/services/sidebar.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SidebarItemDTO } from './sidebar-item/sidebar-item.component';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent {
  @Input() sidebarItems: SidebarItemDTO[];

  constructor() {}
}
